import React, { useEffect } from "react";
import JesseHeadshot from "../assets/JesseHeadshot.jpg";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import GitHubIcon from "@mui/icons-material/GitHub";
import DescriptionIcon from "@mui/icons-material/Description";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import JesseCV from "../assets/Jesse Washburn Resume 2026.pdf";
import "../styles/About.css";

function About() {
  useEffect(() => {
    document.title = "About Me";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      <div className="about-image animate-item animate-delay-1">
        <img src={JesseHeadshot} alt="Jesse Washburn Headshot" />
      </div>
      <h1 className="animate-item animate-delay-2">Jesse Washburn</h1>
      <div className="about-bio">
        <p className="animate-item animate-delay-3">
          Following an itinerant early childhood, Finnish-American software
          developer Jesse Washburn grew up in San Juan, Puerto Rico before
          settling near Baltimore, Maryland. A naturally curious, multifaceted
          thinker, Jesse holds degrees in business, music, and computer science
          and is fluent in English, Spanish, and Finnish.
        </p>
        <p className="animate-item animate-delay-4">
          His professional background includes building cross-platform mobile/web apps, 
          founding and selling a startup, and co-authoring a data science research paper 
          submitted for publication.
        </p>
        <p className="animate-item animate-delay-5">
          Jesse brings to every project a rare blend of creative discipline,
          technical precision, and business acumen, skills honed through years
          of rigorous musical training and sharpened by daily work in full-stack
          development and data-driven problem solving.
        </p>
        <p className="animate-item animate-delay-6">
          He is currently a software engineer and team lead at Open Learning
          Exchange, where he contributes to the ongoing development of the
          organization’s web and mobile apps, with a focus on DevOps automation,
          build performance, and CI/CD reliability.
        </p>
      </div>
      <div className="prompt animate-item animate-delay-7">
        <a
          href="https://www.linkedin.com/in/jesse-washburn-24467428b/"
          target="_blank"
          rel="noopener noreferrer"
          className="animate-item animate-delay-8"
        >
          <LinkedInIcon />
        </a>
        <a href="mailto:jeswashburn@gmail.com" className="animate-item animate-delay-9">
          <EmailIcon />
        </a>
        <a
          href="https://github.com/jessewashburn"
          target="_blank"
          rel="noopener noreferrer"
          className="animate-item animate-delay-10"
        >
          <GitHubIcon />
        </a>
        <a
          href={JesseCV}
          download="JesseWashburn_CV"
          className="download-cv animate-item animate-delay-11"
        >
          <DescriptionIcon />
        </a>
        <a
          href="https://www.youtube.com/watch?v=VZ__PL2cq-0&list=PL1xADrKsHDfwwxVRMX5uK-AkEm5M2rzBM&index=4"
          target="_blank"
          rel="noopener noreferrer"
          className="animate-item animate-delay-12"
        >
          <MusicNoteIcon />
        </a>
      </div>
    </div>
  );
}

export default About;
